import { BUTTON_VARIANT_TYPES, type ButtonBlock } from '@blogforge/shared';
import type { DragPath } from '../../types';
import { useEditorStore } from '../../stores/editorStore';
import VariableInfusedTextEditor, {
  type RichTextEditorHandle,
} from '../tiptap/VariableInfusedTextEditor';
import { useRef } from 'react';
import { Switch } from '../ui/Switch';

interface ButtonInspectorProps {
  block: ButtonBlock;
  path: DragPath;

  variableNameOptions?: string[];
}

export function ButtonInspector({ block, path, variableNameOptions = [] }: ButtonInspectorProps) {
  const richTextRef = useRef<RichTextEditorHandle>(null);
  const updateBlock = useEditorStore((s) => s.updateBlock);
  const attrs = block.attrs;

  const set = (patch: Partial<ButtonBlock['attrs']>) => {
    updateBlock(block.id, { attrs: { ...attrs, ...patch } }, path);
  };

  return (
    <div className="space-y-4">
      <div>
        <label className="field-label">Link</label>
        <VariableInfusedTextEditor
          value={attrs.href || ''}
          onChange={(val, hrefIsMustache) => set({ href: val, hrefIsMustache })}
          placeholder="Add a url... Use @ to reference a variable"
          options={variableNameOptions}
          ref={richTextRef}
          tagsOnly={true}
          maxTags={1}
        />
      </div>

      <div>
        <Switch
          label="Track Clicks"
          checked={attrs.trackHref}
          onChange={(val) =>
            set({
              trackHref: val,
            })
          }
        />
      </div>

      <div>
        <label className="field-label">Button type</label>
        <select
          className="field-input"
          value={block.attrs.variant ?? ''}
          onChange={(e) =>
            updateBlock(
              block.id,
              {
                attrs: {
                  ...block.attrs,
                  variant: e.target.value,
                },
              },
              path,
            )
          }
        >
          {BUTTON_VARIANT_TYPES.map((v) => (
            <option value={v} key={v}>
              {v}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label className="field-label">Button title</label>
        <input
          type="text"
          className="field-input"
          value={block.content ?? ''}
          onChange={(e) =>
            updateBlock(
              block.id,
              {
                content: e.target.value,
              },
              path,
            )
          }
        />
      </div>
    </div>
  );
}
